/**
 * Destinations after digest approval. The writer-facing next door is
 * Tasks · Make notes: Tasks at /tasks/:storyId, and Make notes.
 * IMPORT_NEXT.PATH stays the internal id for the Tasks room. Leftover
 * /path URLs may still resolve. Slice 7's three static buttons are not
 * the home. Upload does not generate. Series notes stay on the series
 * until a book is in context — then Tasks for that book, with row 1
 * still Missing.
 */
import { docsCharacterOffersPathWithBatch } from '../../utils/docsCharacterOffers';
import { seriesCardsPath } from '../../utils/seriesSnapshots';
import { pathRoomPath } from '../../utils/pathRoomPath';
import { plottrackPath } from '../../utils/plottrackPath';

export const IMPORT_NEXT = {
  BOOK_CARDS: 'bibles',
  DOSSIERS: 'dossiers',
  FOCUS: 'focus',
  PATH: 'path',
  DOCS_OFFERS: 'docs-offers',
  PLOT_TRACK: 'plot-track',
};

export const BOOK_CARDS_NEXT_LABEL = 'Make notes';
export const SERIES_CARDS_NEXT_LABEL = 'Series Notes';

export function seriesProjectIdForImport(project, payload) {
  if (payload?.seriesProjectId) return payload.seriesProjectId;
  if (project?.is_series && project.id) return project.id;
  return undefined;
}

export function cardsNextLabel(project) {
  return project?.is_series ? SERIES_CARDS_NEXT_LABEL : BOOK_CARDS_NEXT_LABEL;
}

export function pathForImportNext(next, extras = {}) {
  if (next === IMPORT_NEXT.DOCS_OFFERS) {
    return docsCharacterOffersPathWithBatch({
      projectId: extras.projectId,
      storyId: extras.storyId,
    }, extras.batchId);
  }
  if (next === IMPORT_NEXT.PATH) {
    if (extras.storyId) return `${pathRoomPath(extras.storyId)}?from=import`;
    return null;
  }
  if (next === IMPORT_NEXT.PLOT_TRACK) {
    if (extras.storyId) return plottrackPath(extras.storyId);
    return null;
  }
  if (next === IMPORT_NEXT.BOOK_CARDS || next === IMPORT_NEXT.DOSSIERS) {
    if (extras.seriesProjectId) return seriesCardsPath(extras.seriesProjectId);
    return '/bibles';
  }
  if (next === IMPORT_NEXT.FOCUS) {
    return extras.sessionId ? `/chat/${extras.sessionId}` : '/chat';
  }
  if (extras.discoverySessionId) return `/chat/${extras.discoverySessionId}`;
  return null;
}

export function ideaChatPath(project) {
  const sessionId = project?.discovery_session_id || project?.first_session_id;
  return sessionId ? `/chat/${sessionId}` : '/chat';
}

/** Open the new book's Idea chat with the upload door, instead of All stories. */
export function landCreatedBook(navigate, project, options) {
  if (!options?.openUpload || options?.next) return false;
  navigate(ideaChatPath(project), {
    state: {
      openUpload: true,
      storyId: options.story_id || project?.story_id || null,
      projectId: project?.id || null,
    },
  });
  return true;
}

export function applyImportNext(navigate, payload, fallbackProject, extras = {}) {
  if (payload?.next === IMPORT_NEXT.DOCS_OFFERS) {
    const storyId = payload.story_id || extras.currentStoryId;
    const path = pathForImportNext(IMPORT_NEXT.DOCS_OFFERS, {
      projectId: payload.project_id || fallbackProject?.id,
      storyId,
      batchId: payload.batch_id,
    });
    if (path) navigate(path);
    return;
  }
  if (payload?.next === IMPORT_NEXT.PATH) {
    const storyId = payload.story_id || extras.currentStoryId;
    const path = pathForImportNext(IMPORT_NEXT.PATH, { storyId });
    if (path) navigate(path);
    return;
  }
  const path = pathForImportNext(payload?.next, {
    sessionId: payload?.session?.id,
    discoverySessionId: fallbackProject?.discovery_session_id,
    seriesProjectId: seriesProjectIdForImport(fallbackProject, payload),
    storyId: payload?.story_id || extras.currentStoryId,
    projectId: fallbackProject?.id,
  });
  if (path) navigate(path);
}
